module.exports = __webpack_public_path__ + "assets/img/activity-rules-42d314ab.png";